import Rollbar from 'rollbar';

import { toError } from '@repo/lib/errors';
import { redactSensitiveInfo } from '@repo/lib/strings';
import { env } from './env';

const rollbar = new Rollbar({
  accessToken: 'ec8a136071734ce88866f5ab499679a2', // This is a client only token, so does not need to be kept secret.
  autoInstrument: false,
  enabled: env.VITE_ROLLBAR_ENABLED === true,
  environment: env.VITE_ENV_NAME,
  payload: {
    client: {
      javascript: {
        code_version: env.VITE_GIT_SHA,
        source_map_enabled: true,
      },
    },
  },
  scrubFields: ['email', 'token', 'user_ip', 'zipCode'],
  scrubPaths: [
    'body.trace.extra.request.variables.input.orderTokens.1.value', // Typically email
    'body.trace.extra.request.variables.input.orderTokens.2.value', // Could be zipcode
    'custom.request',
    'custom.response',
  ],
  scrubTelemetryInputs: true,
  transform: (payload: Rollbar.Payload) => {
    const { body } = payload;

    if (body.telemetry) {
      body.telemetry = body.telemetry.map(
        (telemetry: Rollbar.Payload['telemetry']) => {
          return {
            ...telemetry,
            body: {
              ...telemetry.body,
              message: redactSensitiveInfo(telemetry.body.message),
              stack: redactSensitiveInfo(telemetry.body.stack),
            },
          };
        },
      );
    }

    if (body.trace?.exception) {
      body.trace.exception = {
        ...body.trace.exception,
        message: redactSensitiveInfo(body.trace.exception.message),
      };
    }

    if (body.trace?.extra?.response?.errors) {
      body.trace.extra = {
        ...body.trace.extra,
        response: {
          ...body.trace.extra.response,
          errors: Object.keys(body.trace.extra.response.errors).map(
            (key: string) => {
              const error = body.trace.extra.response.errors[key];
              return {
                ...error,
                message: redactSensitiveInfo(error.message),
              };
            },
          ),
        },
      };
    }

    payload.body = body;
  },
});

export const clientLogger = {
  logError: (error: unknown, info?: unknown) => {
    const err = toError(error);
    // rollbar only grabs the message and stack from an error
    // we want to send all the other properties assigned to an error as well
    const { uuid } = rollbar.error(err, { ...err, errorInfo: info });
    return { correlationId: uuid };
  },
  associateErrorsWithRetailer: (retailer: {
    retailerMoniker?: string | null;
    shid?: string | null;
  }) => {
    rollbar.configure({
      payload: {
        custom: {
          retailerMoniker: retailer.retailerMoniker,
          shid: retailer.shid,
        },
      },
    });
  },
};
